var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notfoundcontainer"},[_c('h1',{staticClass:"notfound"},[_vm._v("404, Not Found")])])
}]

export { render, staticRenderFns }